<template>
  <div>
    <sheet :sheetwho="'insheet'" :tbheader="'入库单'" :sheetcolumns="columns" :sheettype="'PI'" :branchflag="'+'"></sheet>
  </div>
</template>

<script>
import sheet from './components/sheet.vue';
import { insheetcolumns } from "@/js/sheettablecolumn";
export default {
  name:"insheet",
  data(){
    return{
      columns:insheetcolumns
    }
  },
  components:{
    sheet
  },
  mounted(){
    /* if (this.sheetwho == "insheet") {
      this.header_info.buyer_no = localStorage.getItem("merchant_id");
      // this.columns = insheetcolumns;
    } else {
      this.header_info.seller_no = localStorage.getItem("merchant_id");
    } */
  }
}
</script>
<style lang="less" scoped>
/deep/.el-input {
  width: 150px !important;
}

/deep/.el-icon-arrow-up:before{
  content:""
}
</style>